import { useState, useEffect } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import * as theme from '../../theme';
import PastScansList from '../../components/dashboards/lists/PastScansList';
import Heading from '../../components/Heading';

export default function PastScans() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [practitionerList, setPractitionerList] = useState([]);
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
      if (practitionerList.length == 0) {
        getManagementData();
        getClientData();
      }
    }, [practitionerList]);

  async function getManagementData() {
    try {
      const docRef = doc(db, "app", 'management');
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setPractitionerList(data.practitioners || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  async function getClientData() {
    try {
      let docRef;
      if (currentUser.role === 'practitioner') {
        docRef = doc(db, "practitioners", currentUser.uid, "clients", "list");
      } else {
        docRef = doc(db, "app", "clientMap");
      }
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setClientList(data.clients || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  function navigateBack() {
    navigate(`/dashboard`);
  }

  return (
    <div style={{ ...theme.Container.flexColumnContainer, ...theme.Container.center800 }}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`Past Scans`}
          onClick={() => navigateBack()}
        />
      </div>
      <div style={theme.Container.flexColumn}>
        <PastScansList currentUser={currentUser} clientList={clientList} practitionerList={practitionerList} />
      </div>
    </div>
  );
}